/**
 * Analytics Event Tracking Helper
 * Centralized location for all analytics event tracking
 */

// Common Event Parameter Keys
export const EVENT_PARAMS = {
  EVENT: "event",
  PAGE_PATH: "page_path",
} as const;

/**
 * Analytics Events Class
 * Contains all event names used in the application
 */

export class Events {
  static readonly whatsappClick = "whatsapp_click";
  static readonly formSubmit = "form_submit_web";
  static readonly initiatePayment = "initiate_payment_web";
  static readonly videoPaymentSuccess = "video_payment_success_web";
  static readonly offlinePaymentSuccess = "offline_payment_success";
  static readonly customizeClickWeb = "customize_click_web";
  // Add more events here as needed
}

/**
 * Analytics Sources Class
 * Contains all source values used in analytics events
 */
export class Sources {
  static readonly form = "form";
  static readonly listingPage = "listing_page";
  static readonly templatePreview = "template_preview";
  // Add more sources here as needed
}

/**
 * Track any analytics event
 * @param eventName - Name of the event to track
 * @param params - Dictionary of event parameters (key-value pairs)
 */
export function trackEvent(
  eventName: string,
  params?: Record<string, any>
): void {
  if (typeof window === "undefined") {
    return;
  }

  const w = window as unknown as {
    dataLayer?: Array<Record<string, any>>;
  };

  w.dataLayer = w.dataLayer || [];

  const eventData: Record<string, any> = {
    [EVENT_PARAMS.EVENT]: eventName,
  };

  // Add all provided parameters
  if (params) {
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined) {
        eventData[key] = params[key];
      }
    });
  }

  // Default to current pathname if page_path is not provided
  if (!eventData[EVENT_PARAMS.PAGE_PATH]) {
    eventData[EVENT_PARAMS.PAGE_PATH] = window.location.pathname;
  }

  w.dataLayer.push(eventData);
}

